<template>
  <div>
    <ejs-button ref='detailBtn' cssClass="e-small" style="margin-right:10px;"
                :isPrimary="true" :isToggle="true"
                v-on:click.native="detailClick">{{ topContent }}</ejs-button>
    <ejs-button ref='deployBtn' cssClass="e-small"
                :isPrimary="true" :isToggle="true"
                v-on:click.native="deployClick">{{ deployContent }}</ejs-button>
  </div>
</template>

<script>
import Vue from 'vue';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import i18n from '../../../../plugins/i18n.js';
import { EventBus } from '../../../../plugins/eventBus';

enableRipple(true);
Vue.use(ButtonPlugin);

export default {
  name: 'DPEnviromentOperButton',
  components: {
  },
  data() {
    return {
      topContent: '部署详情',
      deployContent: '一键部署',
      dpId: ''
    };
  },
  methods: {
    detailClick() {

    },
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    deployClick() {
      this.$refs.deployBtn.$parent.$refs.oneKeyDeploymentPage.show();
      const dpID = `${this.$refs.deployBtn.$parent.$data.data.dpId}`;
      this.dpId = dpID;
      /* if (this.$refs.startBtn.$parent.$data.data.taskState === 1) {
        // this.$layer.alert({ msg: this.$ts('TS.ts_have_start_task') });
        EventBus.$emit('toast', { type: 'warning', content: this.$ts('TS.ts_have_start_task') });
      } else {
        const $this = this;
        this.axios.get(`/lte/ems/ts/startTask.html?taskID=${taskID}`).then((response) => {
          if (response.data.errorCode === 'SUCCESS') {
            // $this.$refs.startBtn.$parent.$data.data.taskState = 1;
            EventBus.$emit('toast', { type: 'success', content: this.$ts('TS.success') });
          } else {
            // this.$layer.alert({ msg: `${response.data.errorString}` });
            EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        });
      } */
    }
  }
};
</script>

<style>

</style>
